import { ArkivPeriode } from './../../../models/arkivPeriode';
import RequestService from '../requestService';
import { client } from '../../client';

export default class ArkivPeriodeService extends RequestService<ArkivPeriode, 'arkivPeriode'>
{
    validateFraDato = async (value : ArkivPeriode) => client.post<boolean>(`${this.serviceName}/ValidateFraDato`,value);
    validateArkivStatus = async (value : ArkivPeriode) => client.post<boolean>(`${this.serviceName}/ValidateArkivStatus`,value);
    validateTilDato = async (value : ArkivPeriode) => client.post<boolean>(`${this.serviceName}/ValidateTilDato`,value);
}